import { HttpClient } from 'api/http-client';
import { Automation } from './types';

class AutomationsHttpClient extends HttpClient {
  public createAutomation(automation: Automation): Promise<Automation> {
    return this.post('/automations', automation);
  }

  public updateAutomation(
    automationId: number,
    automation: Partial<Automation>,
  ): Promise<Automation> {
    return this.put(`/automations/${automationId}`, automation);
  }

  public toggleAutomation(
    automationId: number,
    automation: Partial<Automation>,
  ): Promise<Automation> {
    return this.put(`/automations/${automationId}/enable`, automation);
  }

  public getAutomations(): Promise<Automation[]> {
    return this.get('/automations');
  }

  public createAutomationForReferenceId(
    templateId: number,
    referenceType: string,
    referenceId: number,
    automation: Partial<Automation>,
  ): Promise<Automation> {
    return this.post(
      `/automations/template/${templateId}/${referenceType}/${referenceId}`,
      automation,
    );
  }

  public createGlobalAutomation(
    automation: Omit<Automation, 'automationId'>,
  ): Promise<Automation> {
    return this.post('/automations/global', automation);
  }

  public getGlobalAutomations(): Promise<Automation[]> {
    return this.get('/automations/global');
  }

  public getAutomationForReferenceId(
    templateId: number,
    referenceType: string,
    referenceId: number,
  ): Promise<Automation[]> {
    return this.get(
      `/automations/template/${templateId}/${referenceType}/${referenceId}`,
    );
  }

  public getAutomation(automationId: number): Promise<Automation> {
    return this.get(`/automations/${automationId}`);
  }

  public deleteAutomation(automationId: number): Promise<unknown> {
    return this.delete(`/automations/${automationId}`);
  }
}

export const AutomationsApi = new AutomationsHttpClient();
